import * as React from "react";
// UI Components
import { Row, Col, Typography } from "antd";
// Styles
import styles from "./index.module.scss";

const { Paragraph } = Typography;

interface IProps {
	title: string;
	content?: React.ReactNode;
	children?: React.ReactNode;
}
const InfoRow: React.FC<IProps> = props => {
	return (
		<Row className={styles["info-row"]}>
			<Col span={12} className={styles["info-row__content"]}>
				<Paragraph style={{ marginBottom: 0 }} ellipsis>
					{props.content}
				</Paragraph>
			</Col>
			<Col span={12} className={styles["info-row__title"]}>
				{props.title}
			</Col>
		</Row>
	);
};

export default InfoRow;
